<header id="header" class="fixed-top" [class.header-scrolled]="innerPage" [class.header-inner-pages]="innerPage">
  <div class="container d-flex align-items-center">
    <a routerLink="/" fragment="hero" class="logo me-auto" (click)="closeMobile()">
      <img src="assets/img/AnikinitekLogo.png" alt="Anikinitek" class="img-fluid">
    </a>

    <nav id="navbar" class="navbar" [class.navbar-mobile]="mobileOpen">
      <ul>
        <li><a class="nav-link scrollto" routerLink="/" fragment="hero" routerLinkActive="router-active" [routerLinkActiveOptions]="{ exact: true }" (click)="closeMobile()">Home</a></li>
        <li class="dropdown">
          <a routerLink="/" fragment="products" (click)="closeMobile()"><span>Products</span> <i class="bi bi-chevron-down"></i></a>
          <ul>
            <li class="dropdown">
              <a routerLink="/asset-management" fragment="inventory" (click)="closeMobile()"><span>Asset Management System</span> <i class="bi bi-chevron-right"></i></a>
              <ul>
                <li><a routerLink="/asset-management" fragment="inventory" (click)="closeMobile()">Inventory Management System</a></li>
                <li><a routerLink="/asset-management" fragment="task" (click)="closeMobile()">Task Management System</a></li>
                <li><a routerLink="/asset-management" fragment="ticket" (click)="closeMobile()">Ticket Management System</a></li>
              </ul>
            </li>
            <li><a routerLink="/ecommerce" (click)="closeMobile()">E-Commerce Platform</a></li>
            <li><a routerLink="/erp" fragment="company-website" (click)="closeMobile()">ERP Platform</a></li>
            <li><a routerLink="/career-platform" (click)="closeMobile()">Career Connect Platform</a></li>
            <li><a routerLink="/property-platform" (click)="closeMobile()">Property Platform</a></li>
          </ul>
        </li>
        <li><a class="nav-link scrollto" routerLink="/" fragment="services" (click)="closeMobile()">Services</a></li>
        <li><a class="nav-link" routerLink="/" fragment="about" (click)="closeMobile()">About</a></li>
        <li><a class="nav-link scrollto" routerLink="/" fragment="contact" (click)="closeMobile()">Contact</a></li>
        <li><a class="getstarted scrollto" href="https://calendly.com/anikinitek/30min" target="_blank" rel="noopener" (click)="closeMobile()">Get a Demo</a></li>
      </ul>
      <i class="bi mobile-nav-toggle" [class.bi-list]="!mobileOpen" [class.bi-x]="mobileOpen" (click)="toggleMobile()"></i>
    </nav>
  </div>
</header>
